import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LoggedUser } from '../../redux/Slices/AuthSlice';

const UseLogged = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true)
    const [role, setRole] = useState("")
    const [isLogin, setIsLogin] = useState("")
    let token = localStorage.getItem("token")
    const { IsLogin } = useSelector(state => state.AuthReducer)

    // handle get logged user
    const handleLoggedUser = async () => {
        setLoading(true)
        await dispatch(LoggedUser())
        setLoading(false)
    }

    // run the LoggedUser
    useEffect(() => {
        handleLoggedUser()
    }, [])

    // handle the Logged User request response
    useEffect(() => {
        if (loading === false) {
            if (IsLogin && IsLogin.data) {
                setRole(IsLogin.data.data.role)
                setIsLogin(IsLogin.data.data)
            } else {
                token = localStorage.removeItem("token")
            }
        }
    }, [loading])

    //   logout
    const LogOut = () => {
        localStorage.removeItem("token")
    }

    return [isLogin, LogOut, role, token]

}

export default UseLogged
